<template>
    <group-details :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-10">
            <group-historical-invoices :team-id="props.teamId" :group-id="props.groupId" />
        </div>
    </group-details>
</template>

<script setup>
import GroupHistoricalInvoices from '~/components/settings/billing/GroupHistoricalInvoices.vue';
import GroupDetails from '../form/GroupDetails.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});
</script>
